export interface OrganisationChangeAvailability {
  id: number;
  action: OrganisationChangeAvailabilityAction;
  unitOptionId: number;
}

export enum OrganisationChangeAvailabilityAction {
  Disable = 1,
}
